module.exports = __webpack_public_path__ + "static/media/against-your-will.451bb322.svg";